import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/store/Header";
import { SmoothScroll } from "./components/store/SmoothScroll";
import Store from "./pages/Store";
import ProductPage from "./pages/ProductPage";
import OrderPage from "./pages/OrderPage";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="app-bg min-h-screen">
      <BrowserRouter>
        <SmoothScroll />
        <Header />
        <Routes>
          <Route path="/" element={<Store />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/order/:ref" element={<OrderPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
